const TRANSMISSION_TYPE_KEYS = {
  manual: "vehicle_entry.info.options.manual",
  automatic: "vehicle_entry.info.options.automatic",
  semi_automatic: "vehicle_entry.info.options.semi_automatic",
};

/** Short traction codes — same as stored values; fits the 4×3 cm sticker. */
const TRANSMISSION_LAYOUT_LABEL = {
  front: "front",
  rear: "rear",
  "4x4": "4x4",
};

export function formatTransmissionTypeForLabel(
  transmissionType,
  numberOfGears,
  t,
) {
  if (!transmissionType) return "";
  const key = TRANSMISSION_TYPE_KEYS[transmissionType];
  let label = key ? t(key) : transmissionType;
  const gears =
    numberOfGears != null && numberOfGears !== ""
      ? Number(numberOfGears)
      : NaN;
  if (
    transmissionType === "manual" &&
    Number.isFinite(gears) &&
    gears > 0
  ) {
    label = `${label} ${gears} marce`;
  }
  return label;
}

export function formatTransmissionLayoutForLabel(layout) {
  if (!layout) return "";
  return TRANSMISSION_LAYOUT_LABEL[layout] || layout;
}

export function formatVehicleFuelTransmissionLine(vehicle, supplyLabel, t) {
  const transmission = formatTransmissionTypeForLabel(
    vehicle.transmissionType,
    vehicle.numberOfGears,
    t,
  );
  const layout = formatTransmissionLayoutForLabel(vehicle.transmissionLayout);
  return `${supplyLabel} / ${transmission} / ${layout}`;
}
